import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={14}
    height={15}
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.1006 7.50003H4.83496V4.47952C4.83496 3.31936 5.76367 2.3555 6.92383 2.34378C8.0957 2.33206 9.05371 3.28421 9.05371 4.45315V4.9219C9.05371 5.31155 9.36719 5.62503 9.75684 5.62503H10.6943C11.084 5.62503 11.3975 5.31155 11.3975 4.9219V4.45315C11.3975 1.99222 9.39062 -0.00876022 6.92969 2.88433e-05C4.46875 0.00881791 2.49121 2.03616 2.49121 4.4971V7.50003H1.78809C1.01172 7.50003 0.381836 8.12991 0.381836 8.90628V13.5938C0.381836 14.3701 1.01172 15 1.78809 15H12.1006C12.877 15 13.5068 14.3701 13.5068 13.5938V8.90628C13.5068 8.12991 12.877 7.50003 12.1006 7.50003ZM8.11621 11.9532C8.11621 12.6006 7.5918 13.125 6.94434 13.125C6.29688 13.125 5.77246 12.6006 5.77246 11.9532V10.5469C5.77246 9.89944 6.29688 9.37503 6.94434 9.37503C7.5918 9.37503 8.11621 9.89944 8.11621 10.5469V11.9532Z"
      fill="#0093DD"
    />
  </svg>
);
export default SVGComponent;
